import { render, staticRenderFns } from "./wangduDialog.vue?vue&type=template&id=3445ffe7&"
import script from "./wangduDialog.vue?vue&type=script&lang=js&"
export * from "./wangduDialog.vue?vue&type=script&lang=js&"
import style0 from "./wangduDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports